<template>
<div id="detailContrast">
  <div v-if="filteredSutraVersionList.length">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <router-link class="breadcrumb-item" to="/avatamsaka/chooseCategory">
          {{$t('avatamsaka.category.title')}}
        </router-link>
        <router-link class="breadcrumb-item"
        :to="{path: '/avatamsaka/category/' + versionId}" v-if="filteredVersionList.length">
            《{{$t('avatamsaka.sutras.sutra', {
              'noticeType': $t(`avatamsaka.sutras.sutra0${sutraId}books[${versionId-1}].text`)
            })}}》{{$t('avatamsaka.category.catView')}}
        </router-link>

      </ol>
    </nav>

    <div class="introCover">
    </div>

    <div class="title">
      <h2>{{itemId}}</h2>
    </div>

    <div class="content">
      <div class="boContent">
        <div v-html="treeData.v1"></div>
      </div>
    </div>

    <button
      v-if="prePage !== 'hidden'"
      @click="fetchData('pressPre')"
      class="preButton"
    >
      <router-link :to="{path: '/avatamsaka/version/' + versionId
                    + '/sutra/' + sutraId + '/detail/' + prePage}">
        <div><div>◀</div></div>
      </router-link>
    </button>
    <button
      v-if="nextPage !== 'hidden'"
      @click="fetchData('pressNext')"
      class="nextButton"
    >
      <router-link :to="{path: '/avatamsaka/version/' + versionId
                    + '/sutra/' + sutraId + '/detail/' + nextPage}">
        <div><div>▶</div></div>
      </router-link>
    </button>

    <div class="sheet">
    <b-button v-b-modal.modal-1 v-b-modal.modal-xl>
      {{$t('avatamsaka.levelThree.verChoose')}}
    </b-button>
    <b-modal id="modal-1" ok-only size="xl">
      <DetailContrastTable/>
    </b-modal>

    <b-button v-b-modal.modal-2 v-b-modal.modal-xl>
      {{$t('avatamsaka.levelThree.example')}}
    </b-button>
    <b-modal id="modal-2" ok-only size="xl">
      <DetailContrastTableTwo/>
    </b-modal>
    </div>

    <ul class="textContent">
      <li>
        <div class="title">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[1].text`)
        })}}
        </div>
        <div v-html="treeData.v2"></div>
      </li>
      <li>
        <div class="title">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[2].text`)
        })}}
        </div>
        <div v-html="treeData.v3"></div>
      </li>
      <li>
        <div class="title">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[4].text`)
        })}}
        </div>
        <div v-html="treeData.v5"></div>
      </li>
      <li>
        <div class="title">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[3].text`)
        })}}
        </div>
        <div v-html="treeData.v4"></div>
      </li>
    </ul>
    <div class="last">
      <div class="sectionBack"></div>
      <div class="postScript">
        <div class="title">
          {{$t('avatamsaka.levelThree.postScript')}}
        </div>
        <ul v-html="treeData.ps">
        </ul>
        </div>
    </div>

  </div>
  <div class="noThisVer" v-if="noThisVer">
    {{$t('avatamsaka.other.chooseOtherVer')}}
    <ul>
      <li @click="getVersionPath(1)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[0].text`)
        })}}
      </li>
      <li @click="getVersionPath(2)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[1].text`)
        })}}
      </li>
      <li @click="getVersionPath(3)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[2].text`)
        })}}
      </li>
      <li @click="getVersionPath(4)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[3].text`)
        })}}
      </li>
      <li @click="getVersionPath(5)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[4].text`)
        })}}
      </li>
    </ul>
  </div>

</div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import DetailContrastTable from './DetailContrastTable';
import DetailContrastTableTwo from './DetailContrastTableTwo';

export default {
  name: 'detailContrast',
  data() {
    return {
      picked: 'words',
      read: 'no',
      noThisVer: false,
      vocabulariesContent: 'no change',
      treeData:   
        {
          "id": "",
          "ps": "",
          "v4": "",
          "v5": "",
          "v3": "",
          "v2": "",
          "v1": ""
        },
      prePage: 'pre',
      nextPage: 'next',
    };
  },
  components: {
    DetailContrastTable,
    DetailContrastTableTwo,
  },
  computed: {
    ...mapState(['selected']),
    versionId() {
      return this.$route.params.vid;
    },
    itemId() {
      return this.$route.params.itemId;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    sutraList() {
      return this.$store.state.sutraList;
    },
    versions() {
      return this.$store.getters.versions;
    },
    sutraId() {
      return this.$route.params.sid;
    },
    itemId() {
      return this.$route.params.itemId;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
    filteredSutraList() {
      let listSutra = [...this.sutraList];
      const nowSutraId = Number(this.sutraId);

      if (nowSutraId !== '') {
        listSutra = listSutra.filter(item => item.sutraId === nowSutraId);
      }
      listSutra = listSutra[0].name;
      const listSutraName = this.$i18n.t(listSutra);
      return listSutraName;
    },
    filteredSutraVersionList() {
      let sutraList = [...this.filteredVersionList];

      if (sutraList.length !== 0) {
        sutraList = this.filteredVersionList[0].contents;
      }

      const nowSutraId = Number(this.sutraId);

      if (nowSutraId !== '') {
        sutraList = sutraList.filter(item => item.sutraId === nowSutraId);
      }

      return sutraList;
    },
  },
  watch: {
    filteredSutraVersionList: function noVersion() {

      let versionEx = false;
      const versionList = [...this.filteredVersionList];
      const sutraList = [...this.filteredSutraVersionList]

      if (versionList.length !== undefined) {
        if (versionList.length === 0 || sutraList.length === 0) {
          versionEx = true;
        }
      }

      this.noThisVer = versionEx;
    },
    watch: {
      $route: 'fetchData',
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapMutations(['updateTagClick']),
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
    fetchData(pressBtn) {
      const self = this;
      const myRequest = new Request(`/static/detailContrast/detailV${this.versionId}S${this.sutraId}.json`);
      const fetchItemId = this.itemId;
      fetch(myRequest)
        .then(response => response.json())
        .then((data) => {
          let preIndex;
          let nextIndex;
          const result = data.find(function(item, index, array){
            preIndex = index - 1;
            nextIndex = index + 1;
            return item.id === fetchItemId;
          });
          const preResult = data.find(function(item, index, array){
            return index === preIndex;
          });
          const nextResult = data.find(function(item, index, array){
            return index === nextIndex;
          });

          self.treeData = result;
          self.nextPage = (typeof(nextResult) == 'undefined'? 'hidden' : nextResult.id);
          self.prePage = (typeof(preResult) == 'undefined'? 'hidden' : preResult.id);
        });
    },
  },
  mounted() {
    this.updateTagClick(true);
    this.$store.dispatch('getSutraList');
    this.$store.dispatch('getVersionList');
  },
};
</script>

<style lang="scss" scoped>
#detailContrast {
  position: relative;
  padding-bottom: 0px;
  background: #F8F7D9;

  .preButton {
    left: 0px;
    position: fixed;
    z-index: 2;
    padding: 0px;
    background: rgba(61, 106, 84, 0.9);
    height: 5em;
    a {
      color: #ffffff;
      text-decoration: none;
      > div {
        padding: 7px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center; 
        > div {
          font-size: 0.7em;
        }
      }
    }

  }

  .nextButton {
    right: 0px;
    padding: 0px;
    position: fixed;
    z-index: 2;
    background: rgba(61, 106, 84, 0.9);
    height: 5em;
    a {
      color: #ffffff;
      text-decoration: none;
      > div {
        padding: 7px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center; 
        > div {
          font-size: 0.7em;
        }
      }
    }
  }

  .sheet button {
    color: #2c2515;
    font-weight: 550;
  }

  /deep/ .modal-dialog {
    margin: 0;
    padding: 5vw;
    /deep/ .modal-content {
      width: 90vw;
    }
  }

  .breadcrumb {
    background: transparent;
  }

  .title {
    text-align: left;
    h2 {
      padding: 20px;
    }
  }
  .introCover {
    position: absolute;
    right: 0;
    top: 0;
    width: 50%;
    max-width: 300px;
    min-height: 300px;
    object-position: 140%  90%;
    background-image: url('/static/image/content/lv3Intro-02.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .icon-stop2{
    background: red;
    border: 15px solid blue;
  }

    .noThisVer {
        padding: 45px;
        font-size: 1.2em;
        ul {
            list-style: none;
            li {
                margin: 10px;
                padding: 5px;
                background: rgb(221, 242, 219);
            }
            li:hover {
                cursor: pointer;
                background: rgb(241, 235, 178);
            }
        }
    }

    button {
        margin: 5px 3px;
    }

    .changeTabs {
      margin: 40px 20px;
      margin-bottom: 0px;
      text-align: left;
      display: flex;
      flex-direction: column;
      .tabs {
        margin: 0px 20px;
        ul {
          list-style: none;
          padding: 0px;
          margin: 0px;
          color: #fff;
          li {
            float: left;
            padding: 5px 10px;
            border: 1px solid black;
            border-bottom: none;
            list-style: none;
            background: #505444;
          }

        }
      }
    }

    .sheet {
      float: right;
      margin: 40px;
      button {
        background: hsl(43, 83%, 81%);
        border-color: rgb(128, 106, 59);
      }
    }

    .textContent {
      clear: both;
      list-style-type: none;
      padding: 0px;
      margin: 0px 3em;
      li {
        border-top: dashed 2px #505443;
        list-style-type: none;
        padding: 3em 0em;
        text-align: left;
        .title {
          padding: 0em 0em 1.5em 0em;
          font-weight: 600;
        }
        .title::after {
          content: ' ►';
        }
      }
      li:first-child {
        border-top: none;
      }
    }

    .content {
        display: flex;
        border: 1px solid black;
        margin: 40px 20px;
        margin-top: 0px;
        max-height: 300px;
        height: 20%;
        overflow: auto;
        flex-direction: row;
        text-align: left;
        background: #fff;

        .vocabularies {

            height: 100%;
            width: 25%;
            min-width: 250px;
            flex: initial;
            padding: 10px;
            border-left: 1px solid black;
            position: relative;
            overflow: auto;

            h1 {
                font-family: 'Open Sans', sans-serif;
                font-size: 13pt;
                font-weight: 600;
                text-transform: uppercase;
                color: white;
                cursor: default;
            }

            h4 {
                font-family: 'Open Sans', sans-serif;
                font-size: 8pt;
                font-weight: 400;
                cursor: default;
            }

            h2 {
                font-family: 'Open Sans', sans-serif;
                font-size: 1.1em;
                font-weight: bolder;
                color: #505444;
                cursor: default;
                margin-bottom: 20px;
            }

            @mixin unselectable() {
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

        }

        .boContent {
            flex: 1;
            padding: 5px;
            overflow: scroll;
            -webkit-overflow-scrolling : touch;
            border: none;
            height: 100%;
        }

    }

    .last {
      display: flex;
      position: relative;
      .sectionBack {
        bottom: 0px;
        width: 100%;
        height: 40%;
        background: #AFB69F;
        position: absolute;
      }
      .postScript {
      margin: 4em 2em 2em 2em;
      border: 4px solid #7E8B6B;
      padding: 2em;
      background: #fff;
      position: sticky;
      flex: 2;
      text-align: left;
      align-self: center;
      .title {
        font-weight: 600;
        padding-bottom: 1em;
      }
      ul {
        list-style: none;
        padding: 0px;
        margin: 0px;
        text-align: left;
        /deep/ a:link::after {
          content: '　';
        }
      }
    }
    }
    

    @media (max-width: 768px) {
      .breadcrumb a {
        z-index: 2;
      }

      .content {
        height: 80vh;
      }
    }

    .last {
      .postScript {
        font-size: 0.9em;
        padding: 1em;
        .title {
          font-weight: 600;
          padding-bottom: 1em;
        }
        ul {
          line-height: 1.8em;
          /deep/ a {
            line-height: 1.8em;
          }

          /deep/ a:link::after {
            content: '　';
          }
          /deep/ br {
            content: '　';
            display: block;
            margin-bottom: 1.5em;
          }
        }
      }
    }

  @media (max-width: 768px) {
    .preButton, .nextButton {
      top: 50%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/DetailContrast.vue